import {React, useState,useEffect} from 'react'
import {motion} from 'framer-motion'
import './About.scss';

import { urlFor,client } from '../../client';
import { AppWrap, MotionWrap } from '../../wrapper';
// const abouts=[
//   {title:'web Devlopment',descripation:'I am a good web devloper',imgUrl:images.about01},
//   {title:'web design',descripation:'I am a good web devloper',imgUrl:images.about02},
//   {title:'UI/UX',descripation:'I am a good web devloper',imgUrl:images.about03},
//   {title:'web Animations',descripation:'I am a good web devloper',imgUrl:images.about04},
// ]





function About() {
  const [abouts,setAbouts]=useState([]);

  useEffect(()=>{
    const query='*[_type=="abouts"]';
    client.fetch(query)
      .then((data)=>setAbouts(data))
  },[]);

  return (
    <>
    <h2 className="head-text">I am <span>Freelancer </span>bringing You Programming <br/>and Design from  <span>the Future</span></h2>
    <div className="app__profiles">
      {
        abouts.map((about,index)=>(
          <motion.div
          whileInView={{opacity:1}}
          whileHover={{scale:1.1}}
          transition={{duration:0.5,type:'tween'}}
          className="app__profile-item"
          key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{marginTop:20}}>{about.title}</h2>
            <p className="p-text p-align" style={{marginTop:10}} >{about.description}</p>
          </motion.div>
        )
      )}
    </div>
    </>
  )
}

export default AppWrap(
  MotionWrap(About,'app__about'),
  'about',
  "app__whitebg"
  
  
  );